import { useState, useRef, useEffect, useCallback, useMemo } from "react";

const LOGO_WHITE = "data:image/png;base64,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";
const LOGO_GOLD  = "data:image/png;base64,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";
const LOGO_ON_WHITE = "data:image/png;base64,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";



const TRIMMER_API = "https://d9gp4dwpjw4in.cloudfront.net";

// ── Cognito Config ──────────────────────────────────────────────────────────
const COGNITO = {
  region:   "us-east-2",
  poolId:   "us-east-2_behl3sU6w",
  clientId: "2vfe8cmjtrh3ro424mlkp1e9nt",
  endpoint: "https://cognito-idp.us-east-2.amazonaws.com/",
};

async function cognitoAuth(username, password) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth" },
    body: JSON.stringify({ AuthFlow: "USER_PASSWORD_AUTH", ClientId: COGNITO.clientId, AuthParameters: { USERNAME: username, PASSWORD: password } }),
  });
  return res.json();
}

async function cognitoNewPassword(username, newPassword, session, name) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityProviderService.RespondToAuthChallenge" },
    body: JSON.stringify({
      ChallengeName: "NEW_PASSWORD_REQUIRED", ClientId: COGNITO.clientId,
      ChallengeResponses: { USERNAME: username, NEW_PASSWORD: newPassword, "userAttributes.website": "https://apibuilder.starstandard.org", "userAttributes.name": name || username },
      Session: session,
    }),
  });
  return res.json();
}

async function cognitoForgotPassword(username) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityProviderService.ForgotPassword" },
    body: JSON.stringify({ ClientId: COGNITO.clientId, Username: username }),
  });
  return res.json();
}

async function cognitoConfirmForgotPassword(username, code, newPassword) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1", "X-Amz-Target": "AWSCognitoIdentityProviderService.ConfirmForgotPassword" },
    body: JSON.stringify({ ClientId: COGNITO.clientId, Username: username, ConfirmationCode: code, Password: newPassword }),
  });
  return res.json();
}

// ── Login Screen ─────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [stage, setStage] = useState("login");
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [resetCode, setResetCode] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [resetConfirm, setResetConfirm] = useState("");
  const [panelContent, setPanelContent] = useState(null);

  useEffect(() => {
    fetch(`https://star-standard-content.s3.amazonaws.com/apibuilder-panel.json?t=${Date.now()}`)
      .then(r => r.json()).then(setPanelContent).catch(() => setPanelContent(null));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      const data = await cognitoAuth(email, password);
      if (data.ChallengeName === "NEW_PASSWORD_REQUIRED") { setSession(data.Session); setStage("newpassword"); }
      else if (data.AuthenticationResult) { const tok = data.AuthenticationResult.IdToken; localStorage.setItem("star_token", tok); localStorage.setItem("star_email", email); onLogin(tok, email); }
      else setError(data.message || data.__type || "Login failed");
    } catch { setError("Network error — please try again"); } finally { setLoading(false); }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault(); setError(null);
    if (newPassword !== confirmPassword) { setError("Passwords don't match"); return; }
    setLoading(true);
    try {
      const data = await cognitoNewPassword(email, newPassword, session, fullName);
      if (data.AuthenticationResult) { const tok = data.AuthenticationResult.IdToken; localStorage.setItem("star_token", tok); localStorage.setItem("star_email", email); onLogin(tok, email); }
      else setError(data.message || data.__type || "Failed to set password");
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      const data = await cognitoForgotPassword(email);
      if (data.__type) setError(data.message || data.__type);
      else { setSuccessMsg(`Reset code sent to ${data.CodeDeliveryDetails?.Destination || email}`); setStage("confirm"); }
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault(); setError(null);
    if (resetPassword !== resetConfirm) { setError("Passwords don't match"); return; }
    setLoading(true);
    try {
      const data = await cognitoConfirmForgotPassword(email, resetCode, resetPassword);
      if (data.__type) setError(data.message || data.__type);
      else { setSuccessMsg("Password reset! Please sign in."); setStage("login"); }
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=JetBrains+Mono:wght@300;400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Syne', sans-serif; }
        .login-wrap { min-height: 100vh; display: grid; grid-template-columns: 460px 1fr; }
        .login-left { background: #ffffff; padding: 56px 48px; display: flex; flex-direction: column; justify-content: center; min-height: 100vh; }
        .login-logo-text { font-size: 22px; font-weight: 800; font-style: italic; letter-spacing: -.02em; margin-bottom: 4px; }
        .login-logo-text span:first-child { color: #f59e0b; }
        .login-logo-text span:last-child { color: #242438; }
        .login-logo-sub { font-family: 'JetBrains Mono', monospace; font-size: 9px; letter-spacing: .16em; text-transform: uppercase; color: #6b6880; margin-bottom: 40px; }
        .login-title { font-size: 24px; font-weight: 700; color: #242438; margin-bottom: 6px; }
        .login-subtitle { font-size: 14px; color: #4b5563; margin-bottom: 28px; line-height: 1.5; }
        .login-label { font-family: 'JetBrains Mono', monospace; font-size: 9px; letter-spacing: .12em; text-transform: uppercase; color: #374151; display: block; margin-bottom: 6px; }
        .login-input { width: 100%; background: #f8f7ff; border: 1.5px solid #e8e5f5; border-radius: 8px; padding: 12px 14px; color: #242438; font-family: 'Syne', sans-serif; font-size: 14px; outline: none; transition: border-color .2s; margin-bottom: 16px; }
        .login-input:focus { border-color: #f59e0b; }
        .login-input::placeholder { color: #9ca3af; }
        .login-btn { width: 100%; padding: 13px; border-radius: 8px; border: none; background: #f59e0b; color: #fff; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 15px; cursor: pointer; margin-top: 4px; transition: opacity .2s; }
        .login-btn:hover { opacity: .88; } .login-btn:disabled { opacity: .4; cursor: not-allowed; }
        .login-error { background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 10px 14px; color: #dc2626; font-size: 12px; margin-bottom: 16px; font-family: 'JetBrains Mono', monospace; }
        .login-success { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 10px 14px; color: #16a34a; font-size: 12px; margin-bottom: 16px; font-family: 'JetBrains Mono', monospace; }
        .login-divider { border: none; border-top: 1px solid #f0eeff; margin: 20px 0; }
        .login-link { background: none; border: none; color: #f59e0b; font-family: 'JetBrains Mono', monospace; font-size: 11px; cursor: pointer; text-decoration: underline; display: block; text-align: center; }
        .login-hint { font-size: 12px; color: #6b7280; text-align: center; margin-top: 20px; font-family: 'JetBrains Mono', monospace; line-height: 1.6; }
        .login-right { background: #1c1c2e; padding: 56px 48px; display: flex; flex-direction: column; justify-content: center; position: relative; overflow: hidden; }
        .login-right::before { content: ''; position: absolute; top: -100px; right: -100px; width: 400px; height: 400px; background: radial-gradient(circle, rgba(201,168,76,.15) 0%, transparent 70%); pointer-events: none; }
        .login-right::after { content: ''; position: absolute; bottom: -80px; left: -60px; width: 300px; height: 300px; background: radial-gradient(circle, rgba(20,184,166,.1) 0%, transparent 70%); pointer-events: none; }
        .panel-hero { margin-bottom: 32px; position: relative; z-index: 1; }
        .panel-headline { font-size: 26px; font-weight: 800; color: #f0eeff; margin-bottom: 8px; line-height: 1.2; }
        .panel-tagline { font-size: 14px; color: #d1d5db; line-height: 1.6; margin-bottom: 12px; }
        .panel-badge { display: inline-block; font-family: 'JetBrains Mono', monospace; font-size: 10px; letter-spacing: .08em; color: #f59e0b; background: rgba(201,168,76,.12); border: 1px solid rgba(201,168,76,.2); padding: 4px 12px; border-radius: 20px; }
        .panel-section { margin-bottom: 22px; position: relative; z-index: 1; }
        .panel-section-title { font-family: 'JetBrains Mono', monospace; font-size: 10px; letter-spacing: .12em; text-transform: uppercase; color: #f59e0b; margin-bottom: 10px; }
        .panel-divider { border: none; border-top: 1px solid #363660; margin: 0 0 12px; }
        .panel-item { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 7px; font-size: 13px; color: #e5e7eb; line-height: 1.5; }
        .panel-item::before { content: '·'; color: #f59e0b; flex-shrink: 0; font-weight: 700; }
        .panel-link { display: flex; align-items: center; gap: 6px; font-family: 'JetBrains Mono', monospace; font-size: 11px; color: #d1d5db; text-decoration: none; margin-bottom: 6px; transition: color .15s; }
        .panel-link:hover { color: #f59e0b; }
        .panel-link::before { content: '→'; color: #f59e0b; font-weight: 700; }
        .skeleton { background: #363660; border-radius: 4px; animation: pulse 1.5s infinite; }
        @keyframes pulse { 0%,100%{opacity:.4} 50%{opacity:.8} }
        @media (max-width: 768px) { .login-wrap { grid-template-columns: 1fr; } .login-right { display: none; } }
      `}</style>
      <div className="login-wrap">
        <div className="login-left">
          <div>
            <img src={LOGO_ON_WHITE} alt="STAR" style={{height:36,objectFit:"contain",marginBottom:4}} />
            <div className="login-logo-sub">Build Your API Subset</div>
          </div>

          {stage === "login" && (<>
            <div className="login-title">Welcome back</div>
            <div className="login-subtitle">Sign in to build your STAR API specs to minimal subsets.</div>
            {error && <div className="login-error">{error}</div>}
            {successMsg && <div className="login-success">{successMsg}</div>}
            <form onSubmit={handleLogin}>
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <label className="login-label">Password</label>
              <input className="login-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Signing in…" : "Sign In →"}</button>
            </form>
            <hr className="login-divider" />
            <button className="login-link" onClick={() => { setStage("forgot"); setError(null); setSuccessMsg(null); }}>Forgot password?</button>
            <div className="login-hint">Access is provided by your STAR administrator.<br/>Contact your admin if you need an account.</div>
            <div style={{marginTop:16,padding:"10px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:8,fontSize:13,color:"#1a1a2e",fontWeight:500,textAlign:"center",lineHeight:1.6}}>
              ⚠️ <strong style={{color:"#c9a84c"}}>Beta Version</strong> — This platform is under active development.<br/>
              Generated specs may require review. If in doubt, verify with official STAR documentation or contact the STAR team.
            </div>
          </>)}

          {stage === "newpassword" && (<>
            <div className="login-title">Set your password</div>
            <div className="login-subtitle">First sign in — set a permanent password.</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleNewPassword}>
              <label className="login-label">Your Name</label>
              <input className="login-input" type="text" value={fullName} onChange={e => setFullName(e.target.value)} placeholder="First Last" required />
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min 8 chars, upper+lower+number+symbol" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Repeat password" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Setting…" : "Set Password & Sign In →"}</button>
            </form>
          </>)}

          {stage === "forgot" && (<>
            <div className="login-title">Reset password</div>
            <div className="login-subtitle">Enter your email and we'll send a reset code.</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleForgotPassword}>
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Sending…" : "Send Reset Code →"}</button>
            </form>
            <hr className="login-divider" />
            <button className="login-link" onClick={() => { setStage("login"); setError(null); }}>← Back to sign in</button>
          </>)}

          {stage === "confirm" && (<>
            <div className="login-title">Enter reset code</div>
            <div className="login-subtitle">{successMsg || "Check your email for the reset code."}</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleConfirmReset}>
              <label className="login-label">Reset Code</label>
              <input className="login-input" type="text" value={resetCode} onChange={e => setResetCode(e.target.value)} placeholder="6-digit code" required />
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={resetPassword} onChange={e => setResetPassword(e.target.value)} placeholder="New password" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={resetConfirm} onChange={e => setResetConfirm(e.target.value)} placeholder="Repeat password" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Resetting…" : "Reset Password →"}</button>
            </form>
          </>)}
        </div>

        <div className="login-right">
          {!panelContent ? (
            <>
              <div style={{marginBottom:32}}>
                <div className="skeleton" style={{height:28,width:"70%",marginBottom:10}} />
                <div className="skeleton" style={{height:14,width:"90%",marginBottom:6}} />
                <div className="skeleton" style={{height:14,width:"55%",marginBottom:12}} />
                <div className="skeleton" style={{height:22,width:"60%",borderRadius:20}} />
              </div>
              {[1,2,3].map(i => (
                <div key={i} style={{marginBottom:22}}>
                  <div className="skeleton" style={{height:10,width:"40%",marginBottom:10}} />
                  <div style={{borderTop:"1px solid #363660",marginBottom:10}} />
                  <div className="skeleton" style={{height:10,width:"88%",marginBottom:6}} />
                  <div className="skeleton" style={{height:10,width:"72%",marginBottom:6}} />
                  <div className="skeleton" style={{height:10,width:"80%"}} />
                </div>
              ))}
            </>
          ) : (<>
            <div className="panel-hero">
              <img src={LOGO_GOLD} alt="STAR" style={{height:32,objectFit:"contain",marginBottom:12}} />
              <div className="panel-headline">{panelContent.hero?.headline}</div>
              <div className="panel-tagline">{panelContent.hero?.tagline}</div>
              {panelContent.hero?.badge && <div className="panel-badge">{panelContent.hero.badge}</div>}
            </div>
            {(panelContent.sections || []).map((section, i) => (
              <div key={i} className="panel-section">
                <div className="panel-section-title">{section.title}</div>
                <div className="panel-divider" />
                {(section.items || []).map((item, j) => (
                  <div key={j} className="panel-item">{item}</div>
                ))}
                {(section.links || []).map((link, j) => (
                  <a key={j} href={link.url} className="panel-link" target="_blank" rel="noopener noreferrer">{link.label}</a>
                ))}
              </div>
            ))}
          </>)}
        </div>
      </div>
    </>
  );
}

// ── Method Badge ──────────────────────────────────────────────────────────────
const METHOD_COLORS = {
  GET:    { bg: "rgba(96,165,250,.12)",  color: "#60a5fa" },
  POST:   { bg: "rgba(16,185,129,.12)",  color: "#10b981" },
  PUT:    { bg: "rgba(245,158,11,.12)",  color: "#f59e0b" },
  PATCH:  { bg: "rgba(167,139,250,.12)", color: "#e4c97e" },
  DELETE: { bg: "rgba(239,68,68,.12)",   color: "#ef4444" },
};

function MethodBadge({ method }) {
  const c = METHOD_COLORS[method] || { bg: "rgba(156,163,175,.12)", color: "#9ca3af" };
  return (
    <span style={{ background: c.bg, color: c.color, fontFamily: "var(--mono)",
      fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 4,
      letterSpacing: ".08em", flexShrink: 0 }}>
      {method}
    </span>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
export default function App() {
  const [token, setToken] = useState(() => localStorage.getItem("star_token"));
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem("star_email") || "");
  const [theme, setTheme] = useState(() => localStorage.getItem("star_theme") || "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("star_theme", theme);
  }, [theme]);

  // Step state: upload | select | result
  const [version, setVersion] = useState("latest");
  const [versions, setVersions] = useState([]);
  const [step, setStep] = useState("upload");
  const [content, setContent] = useState("");
  const [fileName, setFileName] = useState("");
  const [specInfo, setSpecInfo] = useState(null);  // { operations, use_cases, title, version }
  const [loading, setLoading] = useState(false);
  const [buildming, setTrimming] = useState(false);
  const [error, setError] = useState(null);

  // Repository state
  const [uploadMode, setUploadMode] = useState("upload"); // "upload" or "repo"
  const [repoVersion, setRepoVersion] = useState("v1.2.0");
  const [repoAPIs, setRepoAPIs] = useState([]);
  const [repoAPI, setRepoAPI] = useState("");
  const [repoLoading, setRepoLoading] = useState(false);

  // Multi-API composer state
  const [composerMode, setComposerMode] = useState(false); // single vs multi
  const [selectedAPIs, setSelectedAPIs] = useState([]); // multi-select
  const [composerTitle, setComposerTitle] = useState("");
  const [merging, setMerging] = useState(false);
  const [mergeResult, setMergeResult] = useState(null);
  const [mergedOps, setMergedOps] = useState([]); // operations from merge
  const [selectedMergedOps, setSelectedMergedOps] = useState(new Set()); // selected ops for subset
  const [subsetting, setSubsetting] = useState(false);
  const [subsetResult, setSubsetResult] = useState(null);
  const [collapsedDomains, setCollapsedDomains] = useState(new Set());

  // Selection state
  const [selectedOps, setSelectedOps] = useState(new Set());
  const [activeUseCase, setActiveUseCase] = useState(null);
  const [filterMethod, setFilterMethod] = useState("ALL");
  const [filterSearch, setFilterSearch] = useState("");

  // Result state
  const [buildResult, setBuildResult] = useState(null);
  const [fixing, setFixing] = useState(false);
  const [fixedYaml, setFixedYaml] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef(null);

  const authHeaders = useMemo(() => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
  }), [token]);

  useEffect(() => {
    if (!token) return;
    fetch(`${TRIMMER_API}/versions`, { headers: authHeaders })
      .then(r => r.json())
      .then(d => {
        const v = d.versions || [];
        setVersions(v);
        if (v.length > 0) setVersion(v[0].version);
      })
      .catch(() => {});
  }, [token]);

  const handleLogin = (tok, email) => { setToken(tok); setUserEmail(email); };
  const handleLogout = useCallback(() => {
    localStorage.removeItem("star_token"); localStorage.removeItem("star_email");
    setToken(null); setUserEmail("");
  }, []);

  const handleFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = e => setContent(e.target.result);
    reader.readAsText(file);
  };

  const handleDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  // Fetch API list from repository
  const fetchRepoAPIs = async (ver) => {
    setRepoLoading(true); setRepoAPIs([]); setRepoAPI("");
    try {
      const res = await fetch(`${TRIMMER_API}/yaml/list?version=${ver}`, { headers: authHeaders });
      const data = await res.json();
      setRepoAPIs(data.apis || []);
      if (data.apis?.length > 0) setRepoAPI(data.apis[0].domain);
    } catch (e) {
      setError(`Failed to load API list: ${e.message}`);
    } finally {
      setRepoLoading(false);
    }
  };

  // Load YAML from repository
  const loadFromRepo = async () => {
    if (!repoAPI) { setError("Please select an API"); return; }
    setLoading(true); setError(null);
    try {
      const res = await fetch(`${TRIMMER_API}/yaml/fetch?version=${repoVersion}&domain=${repoAPI}`, { headers: authHeaders });
      if (res.status === 401) { handleLogout(); return; }
      const data = await res.json();
      if (data.detail) { setError(data.detail); return; }
      setContent(data.content);
      setFileName(`${repoAPI}_${repoVersion}.yaml`);
      // Auto-load spec info
      const res2 = await fetch(`${TRIMMER_API}/trim/list`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({ content: data.content, version: repoVersion }),
      });
      const specData = await res2.json();
      if (specData.detail) { setError(specData.detail); return; }
      setSpecInfo(specData);
      setSelectedOps(new Set());
      setStep("select");
    } catch (e) {
      setError(`Failed to load from repository: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Merge multiple APIs into one composite YAML
  const mergeAPIs = async () => {
    if (selectedAPIs.length < 2) { setError("Select at least 2 APIs to merge"); return; }
    setMerging(true); setError(null); setMergeResult(null);
    setMergedOps([]); setSelectedMergedOps(new Set()); setSubsetResult(null);
    setCollapsedDomains(new Set());
    try {
      const res = await fetch(`${TRIMMER_API}/yaml/merge`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({
          domains: selectedAPIs,
          version: repoVersion,
          title: composerTitle || null,
        }),
      });
      if (res.status === 401) { handleLogout(); return; }
      const data = await res.json();
      if (data.detail) { setError(data.detail); return; }
      setMergeResult(data);
      setMergedOps(data.operations || []);
      // Default: select all operations
      setSelectedMergedOps(new Set((data.operations || []).map(o => o.id)));
    } catch (e) {
      setError(`Merge failed: ${e.message}`);
    } finally {
      setMerging(false);
    }
  };

  // Download full merged YAML
  const downloadMerged = () => {
    if (!mergeResult) return;
    const blob = new Blob([mergeResult.merged_yaml], { type: "text/yaml" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `star_composite_${mergeResult.domains.join("_")}.yaml`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Download subset of merged YAML (selected operations only)
  const downloadSubset = async () => {
    if (!mergeResult || selectedMergedOps.size === 0) return;
    setSubsetting(true); setError(null);
    try {
      const res = await fetch(`${TRIMMER_API}/yaml/merge-subset`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({
          domains: selectedAPIs,
          version: repoVersion,
          title: composerTitle || null,
          selected_ops: Array.from(selectedMergedOps),
        }),
      });
      if (res.status === 401) { handleLogout(); return; }
      const data = await res.json();
      if (data.detail) { setError(data.detail); return; }
      setSubsetResult(data);
      const blob = new Blob([data.merged_yaml], { type: "text/yaml" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = `star_subset_${mergeResult.domains.join("_")}.yaml`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      setError(`Subset failed: ${e.message}`);
    } finally {
      setSubsetting(false);
    }
  };

  const loadSpec = async () => {
    if (!content.trim()) { setError("Please upload or paste a spec first"); return; }
    setLoading(true); setError(null);
    try {
      const res = await fetch(`${TRIMMER_API}/trim/list`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({ content, version: version !== "latest" ? version : null }),
      });
      if (res.status === 401) { handleLogout(); return; }
      const data = await res.json();
      if (data.detail) { setError(data.detail); return; }
      setSpecInfo(data);
      setSelectedOps(new Set());
      setStep("select");
    } catch (e) {
      setError(`Failed to load spec: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const selectUseCase = (uc) => {
    if (activeUseCase?.id === uc.id) {
      // Click again to deselect
      setActiveUseCase(null);
      setSelectedOps(new Set());
    } else {
      setActiveUseCase(uc);
      setSelectedOps(new Set(uc.operation_ids));
    }
  };

  const toggleOp = (opKey) => {
    setActiveUseCase(null); // manual toggle clears quick-select highlight
    setSelectedOps(prev => {
      const next = new Set(prev);
      if (next.has(opKey)) next.delete(opKey);
      else next.add(opKey);
      return next;
    });
  };

  const selectAll = () => {
    if (!specInfo) return;
    setSelectedOps(new Set(specInfo.operations.map(op => `${op.method}:${op.path}`)));
  };

  const selectNone = () => setSelectedOps(new Set());

  const buildSpec = async () => {
    if (selectedOps.size === 0) { setError("Please select at least one operation"); return; }
    setTrimming(true); setError(null);
    try {
      const res = await fetch(`${TRIMMER_API}/trim`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({ content, selected_operations: Array.from(selectedOps), run_validation: true, version: version !== "latest" ? version : null }),
      });
      if (res.status === 401) { handleLogout(); return; }
      const data = await res.json();
      if (data.detail) { setError(data.detail); return; }
      setBuildResult(data);
      setStep("result");
    } catch (e) {
      setError(`Trim failed: ${e.message}`);
    } finally {
      setTrimming(false);
    }
  };

  const downloadBuilt = (yamlOverride) => {
    const yaml = yamlOverride || buildResult?.trimmed_yaml;
    if (!yaml) return;
    const blob = new Blob([yaml], { type: "text/yaml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const base = fileName.replace(".yaml","").replace(".yml","");
    a.download = `${base}_api_built.yaml`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const fixAll = async () => {
    const yamlToFix = fixedYaml || buildResult?.trimmed_yaml;
    if (!yamlToFix) return;
    setFixing(true);
    try {
      const res = await fetch(`${TRIMMER_API}/validate/fix`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({ content: yamlToFix, fix_naming: true, fix_paths: true,
          fix_schemas: true, fix_properties: true, fix_enums: true }),
      });
      const data = await res.json();
      if (data.fixed_yaml) {
        setFixedYaml(data.fixed_yaml);
        // Re-validate the fixed YAML
        const res2 = await fetch(`${TRIMMER_API}/validate`, {
          method: "POST", headers: authHeaders,
          body: JSON.stringify({ content: data.fixed_yaml, mode: "design-time" }),
        });
        const val = await res2.json();
        setBuildResult(prev => ({ ...prev, validation: val, trimmed_yaml: data.fixed_yaml }));
      }
    } catch (e) {
      setError(`Fix failed: ${e.message}`);
    } finally {
      setFixing(false);
    }
  };

  const reset = () => {
    setStep("upload"); setContent(""); setFileName(""); setSpecInfo(null);
    setSelectedOps(new Set()); setBuildResult(null); setError(null);
    setFixedYaml(null); setFixing(false);
  };

  // Filter operations
  const filteredOps = specInfo?.operations?.filter(op => {
    if (filterMethod !== "ALL" && op.method !== filterMethod) return false;
    if (filterSearch && !op.path.toLowerCase().includes(filterSearch.toLowerCase()) &&
        !op.summary.toLowerCase().includes(filterSearch.toLowerCase()) &&
        !op.operation_id.toLowerCase().includes(filterSearch.toLowerCase())) return false;
    return true;
  }) || [];

  if (!token) return <LoginScreen onLogin={handleLogin} />;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=JetBrains+Mono:wght@300;400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --bg:      #1c1c2e; --bg2: #242438; --bg3: #2a2a42;
          --border:  #363660; --border2: #424268;
          --text:    #f0eeff; --muted: #c8c5e0; --dim: #9a98b5;
          --amber:   #f59e0b; --amber2: #d97706;
          --purple:  #c9a84c; --teal: #14b8a6; --green: #10b981;
          --red:     #ef4444;
          --sans: 'Syne', sans-serif; --mono: 'JetBrains Mono', monospace;
        }
        body { background: #1c1c2e; color: var(--text); font-family: var(--sans); font-size: 15px; line-height: 1.7; min-height: 100vh; }

        /* ── LIGHT THEME ── */
        [data-theme="light"] {
          --bg:      #f5f4f0; --bg2: #eeecea; --bg3: #e5e3df;
          --border:  #d0cdc8; --border2: #bfbcb7;
          --text:    #0a0a1a; --muted: #1e1e38; --dim: #3a3a58;
          --amber:   #b45309; --amber2: #92400e;
          --purple:  #b45309; --teal: #0d9488; --green: #059669;
          --red:     #dc2626;
        }
        [data-theme="light"] body { background: #f5f4f0 !important; color: #0a0a1a !important; }
        [data-theme="light"] .topbar { background: #ffffff !important; border-bottom-color: #d0cdc8 !important; }
        [data-theme="light"] .topbar-badge { background: rgba(180,83,9,.1) !important; border-color: rgba(180,83,9,.25) !important; color: #b45309 !important; }
        [data-theme="light"] .topbar-email { color: #1e1e38 !important; }
        [data-theme="light"] .signout-btn { color: #3a3a58 !important; border-color: #bfbcb7 !important; }
        [data-theme="light"] .steps { background: #eeecea !important; border-bottom-color: #d0cdc8 !important; }
        [data-theme="light"] .main { background: #f5f4f0 !important; }
        [data-theme="light"] .repo-card,
        [data-theme="light"] .use-case-card { background: #ffffff !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .use-case-card:hover { border-color: #b45309 !important; background: rgba(180,83,9,.05) !important; }
        [data-theme="light"] .use-case-card.active { border-color: #b45309 !important; background: rgba(180,83,9,.1) !important; }
        [data-theme="light"] .op-row { border-bottom-color: #e5e3df !important; }
        [data-theme="light"] .op-row:hover { background: rgba(0,0,0,.03) !important; }
        [data-theme="light"] .op-path { color: #0a0a1a !important; }
        [data-theme="light"] .op-id { color: #3a3a58 !important; }
        [data-theme="light"] .build-bar { background: #eeecea !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .section-title { color: #0a0a1a !important; }
        [data-theme="light"] .upload-card { background: #ffffff !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .upload-title { color: #0a0a1a !important; }
        [data-theme="light"] .upload-sub { color: #1e1e38 !important; }
        [data-theme="light"] .paste-area {
          background: #ffffff !important;
          border-color: #bfbcb7 !important;
          color: #0a0a1a !important;
        }
        [data-theme="light"] .drop-zone:hover { background: #eeecea !important; }
        [data-theme="light"] .drop-text { color: #1e1e38 !important; }
        [data-theme="light"] .drop-hint { color: #3a3a58 !important; }
        [data-theme="light"] .error-box { background: rgba(220,38,38,.08) !important; border-color: rgba(220,38,38,.3) !important; color: #dc2626 !important; }
        [data-theme="light"] .op-table { background: #ffffff !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .op-row { border-bottom-color: #e5e3df !important; background: transparent !important; }
        [data-theme="light"] .op-row:hover { background: rgba(0,0,0,.03) !important; }
        [data-theme="light"] .op-path { color: #0a0a1a !important; }
        [data-theme="light"] .op-id { color: #3a3a58 !important; }
        [data-theme="light"] .op-domain { color: #3a3a58 !important; }
        [data-theme="light"] .build-bar { background: #eeecea !important; border-color: #d0cdc8 !important; box-shadow: 0 4px 24px rgba(0,0,0,.1) !important; }
        [data-theme="light"] .steps { background: #eeecea !important; border-bottom-color: #d0cdc8 !important; }
        [data-theme="light"] .use-case-label { color: #0a0a1a !important; }
        [data-theme="light"] .use-case-desc { color: #1e1e38 !important; }
        [data-theme="light"] .domain-header { background: rgba(180,83,9,.08) !important; color: #b45309 !important; }
        [data-theme="light"] .result-card { background: #ffffff !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .result-section-title { color: #0a0a1a !important; }

        /* Topbar */
        .topbar { display: flex; align-items: center; gap: 20px; padding: 0 28px; height: 52px;
          background: #2a2d35; border-bottom: 1px solid #3a3d45; position: sticky; top: 0; z-index: 100; }
        .logo { font-size: 17px; font-weight: 800; font-style: italic; letter-spacing: -.02em; flex-shrink: 0; }
        .logo span:first-child { color: var(--amber); }
        .logo span:last-child { color: var(--text); }
        .topbar-badge { font-family: var(--mono); font-size: 10px; letter-spacing: .12em; text-transform: uppercase;
          color: var(--amber); background: rgba(245,158,11,.1); border: 1px solid rgba(245,158,11,.2);
          padding: 3px 8px; border-radius: 4px; }
        .topbar-right { margin-left: auto; display: flex; align-items: center; gap: 14px; }
        .topbar-email { font-family: var(--mono); font-size: 11px; color: var(--muted); }
        .signout-btn { font-family: var(--mono); font-size: 9px; letter-spacing: .1em; text-transform: uppercase;
          background: transparent; border: 1px solid #424268; border-radius: 4px;
          color: var(--dim); padding: 4px 10px; cursor: pointer; transition: all .2s; }
        .signout-btn:hover { border-color: var(--red); color: var(--red); }

        /* Steps indicator */
        .steps { display: flex; align-items: center; gap: 0; padding: 16px 28px;
          background: var(--bg2); border-bottom: 1px solid var(--border); }
        .step-item { display: flex; align-items: center; gap: 8px; }
        .step-num { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center;
          justify-content: center; font-family: var(--mono); font-size: 11px; font-weight: 700;
          border: 2px solid var(--border2); color: var(--dim); transition: all .2s; }
        .step-num.active { border-color: var(--amber); color: var(--amber); background: rgba(245,158,11,.1); }
        .step-num.done { border-color: var(--green); color: var(--green); background: rgba(16,185,129,.1); }
        .step-label { font-family: var(--mono); font-size: 10px; letter-spacing: .08em; text-transform: uppercase;
          color: var(--dim); transition: color .2s; }
        .step-label.active { color: var(--amber); }
        .step-label.done { color: var(--green); }
        .step-connector { width: 40px; height: 1px; background: var(--border2); margin: 0 8px; }

        /* Main layout */
        .main { max-width: 1100px; margin: 0 auto; padding: 32px 28px; }

        /* Upload step */
        .upload-card { background: var(--bg2); border: 1px solid var(--border); border-radius: 14px; padding: 32px; margin-bottom: 20px; }
        .upload-title { font-size: 22px; font-weight: 800; margin-bottom: 6px; }
        .upload-sub { font-family: var(--mono); font-size: 12px; color: var(--muted); margin-bottom: 24px; }
        .drop-zone { border: 2px dashed var(--border2); border-radius: 10px; padding: 48px 20px;
          text-align: center; cursor: pointer; transition: all .2s; background: var(--bg3); }
        .drop-zone.drag-over { border-color: var(--amber); background: rgba(245,158,11,.05); }
        .drop-zone:hover { border-color: var(--amber); background: var(--bg2); }
        .drop-icon { font-size: 36px; margin-bottom: 12px; }
        .drop-text { font-size: 15px; color: var(--muted); margin-bottom: 6px; }
        .drop-hint { font-family: var(--mono); font-size: 10px; color: var(--dim); }
        .or-divider { text-align: center; font-family: var(--mono); font-size: 10px; color: var(--dim);
          margin: 16px 0; letter-spacing: .1em; }
        .paste-area { width: 100%; background: var(--bg); border: 1px solid var(--border); border-radius: 8px;
          padding: 14px; color: #f0dfa0; font-family: var(--mono); font-size: 12px; line-height: 1.7;
          resize: vertical; min-height: 160px; outline: none; transition: border-color .2s; }
        .paste-area:focus { border-color: var(--amber); }
        .paste-area::placeholder { color: var(--dim); }
        .load-btn { width: 100%; padding: 14px; border-radius: 10px; border: none; margin-top: 16px;
          background: linear-gradient(135deg, var(--amber), var(--amber2));
          color: #fff; font-family: var(--sans); font-weight: 700; font-size: 16px;
          cursor: pointer; transition: opacity .2s; }
        .load-btn:hover { opacity: .88; } .load-btn:disabled { opacity: .4; cursor: not-allowed; }

        /* Select step */
        .select-header { display: flex; align-items: flex-start; justify-content: space-between;
          margin-bottom: 24px; gap: 20px; flex-wrap: wrap; }
        .spec-title { font-size: 22px; font-weight: 800; margin-bottom: 4px; }
        .spec-meta { font-family: var(--mono); font-size: 11px; color: var(--muted); }

        /* Use cases */
        .use-cases { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 10px; margin-bottom: 24px; }
        .use-case-card { background: var(--bg2); border: 1px solid var(--border); border-radius: 10px;
          padding: 14px 16px; cursor: pointer; transition: all .2s; }
        .use-case-card:hover { border-color: var(--amber); background: rgba(245,158,11,.05); }
        .use-case-card.active { border-color: var(--amber) !important; background: rgba(245,158,11,.12) !important;
          box-shadow: 0 0 0 2px rgba(245,158,11,.3); }
        .use-case-card.active .use-case-label { color: var(--amber); }
        .use-case-icon { font-size: 20px; margin-bottom: 6px; }
        .use-case-label { font-weight: 700; font-size: 14px; margin-bottom: 4px; }
        .use-case-desc { font-family: var(--mono); font-size: 10px; color: var(--muted); line-height: 1.5; }

        /* Operations filter */
        .ops-filter { display: flex; gap: 8px; margin-bottom: 16px; flex-wrap: wrap; align-items: center; }
        .filter-btn { padding: 6px 14px; border-radius: 6px; border: 1px solid #424268;
          background: transparent; color: var(--muted); font-family: var(--mono); font-size: 10px;
          letter-spacing: .06em; cursor: pointer; transition: all .2s; }
        .filter-btn.active { border-color: var(--amber); color: var(--amber); background: rgba(245,158,11,.1); }
        .filter-search { flex: 1; min-width: 160px; background: var(--bg2); border: 1px solid var(--border2);
          border-radius: 6px; padding: 7px 12px; color: var(--text); font-family: var(--mono); font-size: 11px;
          outline: none; transition: border-color .2s; }
        .filter-search:focus { border-color: var(--amber); }
        .filter-search::placeholder { color: var(--dim); }
        .sel-actions { display: flex; gap: 8px; margin-left: auto; }
        .sel-btn { padding: 6px 12px; border-radius: 6px; border: 1px solid #424268;
          background: transparent; color: var(--dim); font-family: var(--mono); font-size: 10px; cursor: pointer; }
        .sel-btn:hover { color: var(--muted); border-color: var(--border2); }

        /* Operations list */
        .ops-list { background: var(--bg2); border: 1px solid var(--border); border-radius: 10px; overflow: hidden; margin-bottom: 20px; }
        .op-row { display: flex; align-items: center; gap: 12px; padding: 11px 16px;
          border-bottom: 1px solid #363660; cursor: pointer; transition: background .15s; }
        .op-row:last-child { border-bottom: none; }
        .op-row:hover { background: rgba(245,158,11,.04); }
        .op-row.selected { background: rgba(245,158,11,.07); }
        .op-check { width: 16px; height: 16px; accent-color: var(--amber); cursor: pointer; flex-shrink: 0; }
        .op-path { font-family: var(--mono); font-size: 12px; color: var(--teal); flex: 1; }
        .op-summary { font-size: 12px; color: var(--muted); flex: 1; }
        .op-id { font-family: var(--mono); font-size: 10px; color: var(--dim); }

        /* Trim button */
        .build-bar { display: flex; align-items: center; gap: 16px; background: var(--bg2);
          border: 1px solid #363660; border-radius: 10px; padding: 16px 20px;
          position: sticky; bottom: 16px; z-index: 50;
          box-shadow: 0 4px 24px rgba(0,0,0,.4); margin-top: 16px; }
        .build-count { font-family: var(--mono); font-size: 12px; color: var(--muted); }
        .build-count strong { color: var(--amber); }
        .build-btn { padding: 12px 28px; border-radius: 8px; border: none; margin-left: auto;
          background: linear-gradient(135deg, var(--amber), var(--amber2));
          color: #fff; font-family: var(--sans); font-weight: 700; font-size: 15px;
          cursor: pointer; transition: opacity .2s; }
        .build-btn:hover { opacity: .88; } .build-btn:disabled { opacity: .4; cursor: not-allowed; }

        /* Result step */
        .result-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 24px; }
        .stat-card { background: var(--bg2); border: 1px solid var(--border); border-radius: 10px; padding: 18px 20px; }
        .stat-label { font-family: var(--mono); font-size: 10px; letter-spacing: .1em; text-transform: uppercase;
          color: var(--muted); margin-bottom: 10px; }
        .stat-row { display: flex; justify-content: space-between; align-items: center;
          padding: 6px 0; border-bottom: 1px solid #363660; font-size: 13px; }
        .stat-row:last-child { border-bottom: none; }
        .stat-before { color: var(--dim); font-family: var(--mono); font-size: 12px; }
        .stat-after { color: var(--amber); font-family: var(--mono); font-size: 12px; font-weight: 700; }
        .stat-reduction { color: var(--green); font-family: var(--mono); font-size: 10px; }
        .download-btn { width: 100%; padding: 14px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, var(--green), #059669);
          color: #fff; font-family: var(--sans); font-weight: 700; font-size: 16px;
          cursor: pointer; transition: opacity .2s; margin-bottom: 12px; }
        .download-btn:hover { opacity: .88; }
        .restart-btn { width: 100%; padding: 12px; border-radius: 8px; border: 1px solid #424268;
          background: transparent; color: var(--muted); font-family: var(--mono); font-size: 11px;
          cursor: pointer; transition: all .2s; }
        .restart-btn:hover { border-color: var(--amber); color: var(--amber); }
        .validation-banner { border-radius: 10px; padding: 14px 18px; margin-bottom: 16px;
          display: flex; align-items: center; gap: 12px; font-size: 14px; font-weight: 700; }
        .validation-banner.valid { background: rgba(16,185,129,.1); border: 1px solid rgba(16,185,129,.3); color: var(--green); }
        .validation-banner.invalid { background: rgba(239,68,68,.1); border: 1px solid rgba(239,68,68,.3); color: var(--red); }
        .error-box { background: rgba(239,68,68,.08); border: 1px solid rgba(239,68,68,.3); border-radius: 10px;
          padding: 14px 18px; color: var(--red); font-family: var(--mono); font-size: 12px; margin-bottom: 16px; }
      `}</style>

      {/* Topbar */}
      <div className="topbar">
        <div style={{display:"flex",alignItems:"center",gap:10}}><img src={LOGO_WHITE} alt="STAR" style={{height:26,objectFit:"contain",filter: theme === "light" ? "invert(1) sepia(1) saturate(2) hue-rotate(185deg) brightness(0.3)" : "none"}} /><span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",letterSpacing:".06em"}}>API Builder</span></div>
        <div className="topbar-badge">STAR Platform</div>
        {fileName && (
          <div style={{fontFamily:"var(--mono)",fontSize:10,color:"#e4c97e",
            background:"rgba(201,168,76,.1)",border:"1px solid rgba(201,168,76,.25)",
            borderRadius:4,padding:"3px 10px",maxWidth:260,overflow:"hidden",
            textOverflow:"ellipsis",whiteSpace:"nowrap"}}
            title={fileName}>
            📄 {fileName}
          </div>
        )}
        {versions.length > 0 && (
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",letterSpacing:".08em",textTransform:"uppercase"}}>Version</span>
            <select value={version} onChange={e => setVersion(e.target.value)}
              style={{background:"#2a2d35",border:"1px solid rgba(201,168,76,.3)",borderRadius:5,
                color:"#e4c97e",fontFamily:"var(--mono)",fontSize:10,padding:"3px 8px",cursor:"pointer",outline:"none"}}>
              {versions.map(v => (
                <option key={v.version} value={v.version}>{v.display_label || v.version}{!v.display_label && v === versions[0] ? " (latest)" : ""}</option>
              ))}
            </select>
            {/* Branch + indexed date badge */}
            {(() => {
              const activeVersion = versions.find(v => v.version === version) || versions[0];
              if (!activeVersion) return null;
              const indexedDate = activeVersion.indexed_at
                ? new Date(activeVersion.indexed_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
                : null;
              return (
                <span title={`Branch: ${activeVersion.branch}\nIndexed: ${indexedDate || "unknown"}`}
                  style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",
                    padding:"3px 8px",borderRadius:5,border:"1px solid #2a2a40",
                    cursor:"default",whiteSpace:"nowrap",overflow:"hidden",
                    textOverflow:"ellipsis",maxWidth:200}}>
                  {activeVersion.display_label || activeVersion.branch}{indexedDate ? ` · ${indexedDate}` : ""}
                </span>
              );
            })()}
          </div>
        )}
        <div className="topbar-right">
          <button
            onClick={() => setTheme(t => t === "dark" ? "light" : "dark")}
            title={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
            style={{
              background: theme === "light" ? "#e0dcd8" : "transparent",
              border: theme === "light" ? "1px solid #9a9888" : "1px solid var(--border2)",
              borderRadius:4,
              color: theme === "light" ? "#0a0a1a" : "var(--text)",
              fontSize:15,cursor:"pointer",padding:"3px 8px",lineHeight:1,
              boxShadow: theme === "light" ? "0 1px 3px rgba(0,0,0,.15)" : "none"}}>
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
          <span className="topbar-email">{userEmail}</span>
          <button className="signout-btn" onClick={handleLogout}>Sign out</button>
        </div>
      </div>

      {/* Steps */}
      <div className="steps">
        {[
          { id: "upload", num: 1, label: "Upload Spec" },
          { id: "select", num: 2, label: "Select Operations" },
          { id: "result", num: 3, label: "Download Built API" },
        ].map((s, i) => {
          const isDone = (s.id === "upload" && (step === "select" || step === "result")) ||
                         (s.id === "select" && step === "result");
          const isActive = step === s.id;
          return (
            <div key={s.id} style={{display:"flex",alignItems:"center"}}>
              {i > 0 && <div className="step-connector" />}
              <div className="step-item">
                <div className={`step-num ${isActive ? "active" : isDone ? "done" : ""}`}>
                  {isDone ? "✓" : s.num}
                </div>
                <div className={`step-label ${isActive ? "active" : isDone ? "done" : ""}`}>{s.label}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="main">
        {error && <div className="error-box">❌ {error}</div>}

        {/* Privacy notice */}
        <div style={{marginBottom:16,padding:"10px 16px",
          background:"rgba(16,185,129,.06)",border:"1px solid rgba(16,185,129,.2)",
          borderRadius:8,fontFamily:"var(--mono)",fontSize:12,
          color:"var(--muted)",lineHeight:1.7}}>
          🔒 <strong style={{color:"var(--green)"}}>Private & Secure</strong> — Your API specs are processed in memory only.
          Nothing is stored on our servers or shared with third parties.
        </div>

        {/* ── STEP 1: UPLOAD ── */}
        {step === "upload" && (
          <div className="upload-card">
            {/* Mode tabs */}
            <div style={{display:"flex",gap:0,marginBottom:24,borderRadius:8,overflow:"hidden",border:"1px solid var(--border2)"}}>
              <button onClick={() => setUploadMode("upload")}
                style={{flex:1,padding:"10px 0",border:"none",cursor:"pointer",fontFamily:"var(--mono)",
                  fontSize:11,letterSpacing:".06em",textTransform:"uppercase",transition:"all .2s",
                  background: uploadMode === "upload" ? "var(--amber)" : "var(--bg3)",
                  color: uploadMode === "upload" ? "#1a1f2e" : "var(--muted)",fontWeight: uploadMode === "upload" ? 700 : 400}}>
                📂 Upload File
              </button>
              <button onClick={() => { setUploadMode("repo"); if (repoAPIs.length === 0) fetchRepoAPIs(repoVersion); }}
                style={{flex:1,padding:"10px 0",border:"none",cursor:"pointer",fontFamily:"var(--mono)",
                  fontSize:11,letterSpacing:".06em",textTransform:"uppercase",transition:"all .2s",
                  background: uploadMode === "repo" ? "var(--amber)" : "var(--bg3)",
                  color: uploadMode === "repo" ? "#1a1f2e" : "var(--muted)",fontWeight: uploadMode === "repo" ? 700 : 400}}>
                🗄 STAR Repository
              </button>
            </div>

            {uploadMode === "upload" && (<>
              <div className="upload-title">Upload your STAR API spec</div>
              <div className="upload-sub">Drop a monolith YAML file or paste content — we'll show you all operations to choose from</div>
              <div
                className={`drop-zone ${dragOver ? "drag-over" : ""}`}
                onDrop={handleDrop}
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onClick={() => fileRef.current?.click()}
              >
                <input ref={fileRef} type="file" accept=".yaml,.yml,.json" style={{display:"none"}}
                  onChange={e => handleFile(e.target.files[0])} />
                <div className="drop-icon">{fileName ? "✅" : "📂"}</div>
                <div className="drop-text">{fileName ? fileName : "Drop file here or click to browse"}</div>
                <div className="drop-hint">{fileName ? `${content.split('\n').length} lines loaded` : ".yaml · .yml · .json"}</div>
              </div>
              <div className="or-divider">— OR PASTE CONTENT —</div>
              <textarea className="paste-area" value={content} onChange={e => setContent(e.target.value)}
                placeholder={"openapi: '3.0.3'\ninfo:\n  title: Repair Order API\n  version: 1.0.0\npaths:\n  /repair-orders:\n    ..."} />
              <button className="load-btn" onClick={loadSpec} disabled={loading || !content.trim()}>
                {loading ? "Loading spec…" : "Load Spec & Select Operations →"}
              </button>
            </>)}

            {uploadMode === "repo" && (<>
              <div className="upload-title">Select from STAR Repository</div>
              <div className="upload-sub">Load any STAR API spec directly from the versioned repository — no downloading needed</div>

              {/* Version selector */}
              <div style={{marginBottom:16}}>
                <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>STAR Version</div>
                <div style={{display:"flex",gap:8}}>
                  {versions.length > 0 ? versions.map(v => (
                    <button key={v.version} onClick={() => { setRepoVersion(v.version); fetchRepoAPIs(v.version); }}
                      style={{padding:"8px 16px",borderRadius:7,border:"1px solid",cursor:"pointer",
                        fontFamily:"var(--mono)",fontSize:11,fontWeight:700,transition:"all .2s",
                        borderColor: repoVersion === v.version ? "var(--amber)" : "var(--border2)",
                        background: repoVersion === v.version ? "rgba(201,168,76,.15)" : "var(--bg3)",
                        color: repoVersion === v.version ? "var(--amber)" : "var(--muted)"}}>
                      {v.version}
                    </button>
                  )) : ["v1.2.0","v1.1.0","v1.0.0"].map(v => (
                    <button key={v} onClick={() => { setRepoVersion(v); fetchRepoAPIs(v); }}
                      style={{padding:"8px 16px",borderRadius:7,border:"1px solid",cursor:"pointer",
                        fontFamily:"var(--mono)",fontSize:11,fontWeight:700,transition:"all .2s",
                        borderColor: repoVersion === v ? "var(--amber)" : "var(--border2)",
                        background: repoVersion === v ? "rgba(201,168,76,.15)" : "var(--bg3)",
                        color: repoVersion === v ? "var(--amber)" : "var(--muted)"}}>
                      {v}
                    </button>
                  ))}
                </div>
              </div>

              {/* API selector — single or multi */}
              <div style={{marginBottom:16}}>
                {/* Mode toggle */}
                <div style={{display:"flex",gap:8,marginBottom:12}}>
                  <button onClick={() => { setComposerMode(false); setSelectedAPIs([]); setMergeResult(null); }}
                    style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".06em",
                      padding:"5px 14px",borderRadius:6,cursor:"pointer",
                      background: !composerMode ? "rgba(201,168,76,.2)" : "var(--bg3)",
                      border: !composerMode ? "1px solid rgba(201,168,76,.5)" : "1px solid var(--border2)",
                      color: !composerMode ? "var(--amber)" : "var(--muted)"}}>
                    Single API
                  </button>
                  <button onClick={() => { setComposerMode(true); setRepoAPI(""); setMergeResult(null); }}
                    style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".06em",
                      padding:"5px 14px",borderRadius:6,cursor:"pointer",
                      background: composerMode ? "rgba(138,101,255,.2)" : "var(--bg3)",
                      border: composerMode ? "1px solid rgba(138,101,255,.5)" : "1px solid var(--border2)",
                      color: composerMode ? "#a78bfa" : "var(--muted)"}}>
                    ⚡ Multi-API Composer <span style={{fontSize:8,opacity:.7}}>BETA</span>
                  </button>
                </div>

                <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>
                  {composerMode ? `Select 2–6 APIs to merge (${selectedAPIs.length} selected)` : `Select API ${repoAPIs.length > 0 ? `(${repoAPIs.length} available)` : ""}`}
                </div>

                {repoLoading ? (
                  <div style={{padding:"12px 0",fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>Loading APIs…</div>
                ) : composerMode ? (
                  /* Multi-select list */
                  <div style={{maxHeight:220,overflowY:"auto",border:"1px solid var(--border2)",borderRadius:8,background:"var(--bg3)"}}>
                    {repoAPIs.length === 0 ? (
                      <div style={{padding:"12px 14px",fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>Select a version above to load APIs</div>
                    ) : repoAPIs.map(a => {
                      const checked = selectedAPIs.includes(a.domain);
                      return (
                        <div key={a.domain}
                          onClick={() => setSelectedAPIs(prev =>
                            checked ? prev.filter(d => d !== a.domain)
                                    : prev.length < 6 ? [...prev, a.domain] : prev
                          )}
                          style={{display:"flex",alignItems:"center",gap:10,padding:"8px 14px",
                            cursor:"pointer",borderBottom:"1px solid var(--border)",
                            background: checked ? "rgba(138,101,255,.08)" : "transparent",
                            transition:"background .15s"}}>
                          <div style={{width:14,height:14,borderRadius:3,flexShrink:0,
                            background: checked ? "#a78bfa" : "transparent",
                            border: checked ? "1px solid #a78bfa" : "1px solid var(--border2)",
                            display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#1c1c2e"}}>
                            {checked ? "✓" : ""}
                          </div>
                          <span style={{fontFamily:"var(--mono)",fontSize:11,
                            color: checked ? "#a78bfa" : "var(--text)"}}>
                            {a.domain}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  /* Single select */
                  <select value={repoAPI} onChange={e => setRepoAPI(e.target.value)}
                    style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",
                      borderRadius:8,padding:"11px 14px",color:"var(--text)",fontFamily:"var(--mono)",
                      fontSize:12,outline:"none",cursor:"pointer"}}>
                    {repoAPIs.length === 0 ? (
                      <option value="">Select a version above to load APIs</option>
                    ) : repoAPIs.map(a => (
                      <option key={a.domain} value={a.domain}>{a.domain}</option>
                    ))}
                  </select>
                )}
              </div>

              {/* Composer — selected chips + title + merge button */}
              {composerMode && (
                <div style={{marginBottom:16}}>
                  {selectedAPIs.length > 0 && (
                    <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:12}}>
                      {selectedAPIs.map(d => (
                        <div key={d} style={{display:"flex",alignItems:"center",gap:6,
                          background:"rgba(138,101,255,.15)",border:"1px solid rgba(138,101,255,.3)",
                          borderRadius:20,padding:"4px 10px",fontFamily:"var(--mono)",fontSize:10,color:"#a78bfa"}}>
                          {d}
                          <span onClick={() => setSelectedAPIs(prev => prev.filter(x => x !== d))}
                            style={{cursor:"pointer",opacity:.7,fontSize:12}}>×</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <input
                    value={composerTitle}
                    onChange={e => setComposerTitle(e.target.value)}
                    placeholder="Composite API title (optional)"
                    style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",
                      borderRadius:8,padding:"9px 14px",color:"var(--text)",fontFamily:"var(--mono)",
                      fontSize:11,outline:"none",marginBottom:12}}
                  />
                  <button onClick={mergeAPIs}
                    disabled={selectedAPIs.length < 2 || merging}
                    style={{width:"100%",fontFamily:"var(--mono)",fontSize:11,letterSpacing:".06em",
                      background: selectedAPIs.length >= 2 ? "linear-gradient(135deg,#7c3aed,#a78bfa)" : "var(--bg3)",
                      border:"none",borderRadius:8,color: selectedAPIs.length >= 2 ? "#fff" : "var(--muted)",
                      padding:"12px",cursor: selectedAPIs.length >= 2 ? "pointer" : "not-allowed",fontWeight:600}}>
                    {merging ? "⏳ Merging APIs…" : `⚡ Merge ${selectedAPIs.length} APIs →`}
                  </button>

                  {/* Merge result */}
                  {mergeResult && (
                    <div style={{marginTop:16}}>
                      {/* Stats bar */}
                      <div style={{background:"rgba(138,101,255,.06)",
                        border:"1px solid rgba(138,101,255,.2)",borderRadius:8,padding:"12px 16px",marginBottom:12}}>
                        <div style={{fontFamily:"var(--mono)",fontSize:11,color:"#a78bfa",fontWeight:600,marginBottom:6}}>
                          ✅ Merged — Select Operations to Include
                        </div>
                        <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",lineHeight:1.8}}>
                          <span style={{marginRight:16}}>⚡ {mergeResult.total_ops} total ops</span>
                          <span style={{marginRight:16}}>📦 {mergeResult.total_schemas} schemas</span>
                          {mergeResult.deduped > 0 && <span style={{color:"#fbbf24"}}>⚠️ {mergeResult.deduped} dupes removed</span>}
                        </div>
                      </div>

                      {/* Operations selection */}
                      {mergedOps.length > 0 && (
                        <div>
                          {/* Select all / none */}
                          <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                            <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",flex:1}}>
                              {selectedMergedOps.size} of {mergedOps.length} operations selected
                            </div>
                            <button onClick={() => setSelectedMergedOps(new Set(mergedOps.map(o => o.id)))}
                              style={{fontFamily:"var(--mono)",fontSize:8,background:"transparent",
                                border:"1px solid var(--border2)",borderRadius:4,color:"var(--muted)",
                                padding:"3px 8px",cursor:"pointer"}}>All</button>
                            <button onClick={() => setSelectedMergedOps(new Set())}
                              style={{fontFamily:"var(--mono)",fontSize:8,background:"transparent",
                                border:"1px solid var(--border2)",borderRadius:4,color:"var(--muted)",
                                padding:"3px 8px",cursor:"pointer"}}>None</button>
                            <button onClick={() => setSelectedMergedOps(new Set(mergedOps.filter(o=>o.is_write).map(o=>o.id)))}
                              style={{fontFamily:"var(--mono)",fontSize:8,background:"transparent",
                                border:"1px solid var(--border2)",borderRadius:4,color:"#fbbf24",
                                padding:"3px 8px",cursor:"pointer"}}>Writes only</button>
                          </div>

                          {/* Ops grouped by domain — collapsible */}
                          <div style={{maxHeight:380,overflowY:"auto",border:"1px solid var(--border2)",
                            borderRadius:8,background:"var(--bg3)"}}>
                            {Object.entries(mergedOps.reduce((acc, op) => {
                              acc[op.domain] = acc[op.domain] || [];
                              acc[op.domain].push(op);
                              return acc;
                            }, {})).map(([domain, ops]) => {
                              const domainCollapsed = collapsedDomains.has(domain);
                              const domainSelected = ops.filter(o => selectedMergedOps.has(o.id)).length;
                              return (
                              <div key={domain}>
                                {/* Domain header — clickable to collapse */}
                                <div
                                  onClick={() => setCollapsedDomains(prev => {
                                    const next = new Set(prev);
                                    if (next.has(domain)) next.delete(domain);
                                    else next.add(domain);
                                    return next;
                                  })}
                                  style={{padding:"9px 14px",background:"rgba(138,101,255,.12)",
                                    fontFamily:"var(--mono)",fontSize:11,color:"#a78bfa",fontWeight:600,
                                    letterSpacing:".06em",textTransform:"uppercase",
                                    borderBottom:"1px solid var(--border)",
                                    display:"flex",alignItems:"center",justifyContent:"space-between",
                                    cursor:"pointer",userSelect:"none",
                                    transition:"background .15s"}}
                                  onMouseOver={e => e.currentTarget.style.background="rgba(138,101,255,.2)"}
                                  onMouseOut={e => e.currentTarget.style.background="rgba(138,101,255,.12)"}>
                                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                                    <span style={{fontSize:9,color:"#a78bfa",transition:"transform .2s",
                                      display:"inline-block",transform: domainCollapsed ? "rotate(-90deg)" : "rotate(0deg)"}}>▾</span>
                                    <span>{domain}</span>
                                  </div>
                                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                                    <span style={{color:"#22c55e",fontWeight:400,fontSize:9}}>
                                      {domainSelected}/{ops.length} selected
                                    </span>
                                  </div>
                                </div>
                                {/* Operations — hidden when collapsed */}
                                {!domainCollapsed && ops.map(op => {
                                  const checked = selectedMergedOps.has(op.id);
                                  const methodColor = {
                                    GET:"#22c55e",POST:"#fbbf24",PUT:"#3b82f6",
                                    PATCH:"#8b5cf6",DELETE:"#ef4444"
                                  }[op.method] || "#6b7280";
                                  return (
                                    <div key={op.id}
                                      onClick={() => setSelectedMergedOps(prev => {
                                        const next = new Set(prev);
                                        if (next.has(op.id)) next.delete(op.id);
                                        else next.add(op.id);
                                        return next;
                                      })}
                                      style={{display:"flex",alignItems:"center",gap:10,
                                        padding:"10px 14px",cursor:"pointer",
                                        borderBottom:"1px solid var(--border)",
                                        background: checked ? "rgba(138,101,255,.06)" : "transparent",
                                        transition:"background .1s"}}>
                                      <div style={{width:16,height:16,borderRadius:3,flexShrink:0,
                                        background: checked ? "#a78bfa" : "transparent",
                                        border: checked ? "1px solid #a78bfa" : "1px solid var(--border2)",
                                        display:"flex",alignItems:"center",justifyContent:"center",
                                        fontSize:11,color:"#1c1c2e",fontWeight:700}}>
                                        {checked ? "✓" : ""}
                                      </div>
                                      <span style={{fontFamily:"var(--mono)",fontSize:11,fontWeight:700,
                                        color:methodColor,width:54,flexShrink:0}}>{op.method}</span>
                                      <span style={{fontFamily:"var(--mono)",fontSize:12,
                                        color: checked ? "var(--text)" : "var(--muted)",
                                        flex:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                                        {op.path}
                                      </span>
                                      <span style={{fontFamily:"var(--mono)",fontSize:10,
                                        color:"var(--dim)",flexShrink:0,maxWidth:160,
                                        whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                                        {op.operationId}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                              );
                            })}
                          </div>

                          {/* Download buttons */}
                          <div style={{display:"flex",gap:8,marginTop:10}}>
                            <button onClick={downloadSubset}
                              disabled={selectedMergedOps.size === 0 || subsetting}
                              style={{flex:2,fontFamily:"var(--mono)",fontSize:10,
                                background: selectedMergedOps.size > 0 ? "linear-gradient(135deg,#7c3aed,#a78bfa)" : "var(--bg3)",
                                border:"none",borderRadius:6,
                                color: selectedMergedOps.size > 0 ? "#fff" : "var(--muted)",
                                padding:"10px",cursor: selectedMergedOps.size > 0 ? "pointer" : "not-allowed",
                                fontWeight:600}}>
                              {subsetting ? "⏳ Building..." : `⬇ Download Subset (${selectedMergedOps.size} ops)`}
                            </button>
                            <button onClick={downloadMerged}
                              style={{flex:1,fontFamily:"var(--mono)",fontSize:9,
                                background:"transparent",border:"1px solid rgba(138,101,255,.3)",
                                borderRadius:6,color:"#a78bfa",padding:"10px",cursor:"pointer"}}>
                              ⬇ Full Merge
                            </button>
                          </div>
                          <div style={{marginTop:6,fontFamily:"var(--mono)",fontSize:8,
                            color:"var(--muted)",textAlign:"center"}}>
                            ⚠️ Beta — review cross-domain schema references before production use
                          </div>
                          {subsetResult && (
                            <div style={{marginTop:8,fontFamily:"var(--mono)",fontSize:9,
                              color:"#22c55e",textAlign:"center"}}>
                              ✅ Downloaded: {subsetResult.total_ops} ops · {subsetResult.total_schemas} schemas
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Single API — Selected API info + Download button */}
              {!composerMode && repoAPI && (
                <div style={{background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.2)",
                  borderRadius:8,padding:"12px 16px",marginBottom:20,fontFamily:"var(--mono)",fontSize:11,
                  display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                  <div>
                    <span style={{color:"var(--amber)"}}>📄 {repoAPI}.yaml</span>
                    <span style={{color:"var(--dim)",marginLeft:12}}>from {repoVersion} repository</span>
                  </div>
                  <button
                    onClick={async () => {
                      try {
                        const res = await fetch(`${TRIMMER_API}/yaml/fetch?version=${repoVersion}&domain=${repoAPI}`, { headers: authHeaders });
                        const data = await res.json();
                        if (data.content) {
                          const blob = new Blob([data.content], { type: "text/yaml" });
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = `${repoAPI}.yaml`;
                          a.click();
                          URL.revokeObjectURL(url);
                        }
                      } catch(e) { alert("Download failed: " + e.message); }
                    }}
                    style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".06em",
                      background:"rgba(201,168,76,.12)",border:"1px solid rgba(201,168,76,.4)",
                      borderRadius:6,color:"var(--amber)",padding:"5px 12px",
                      cursor:"pointer",transition:"all .2s",whiteSpace:"nowrap"}}
                    onMouseOver={e=>{e.currentTarget.style.background="rgba(201,168,76,.22)"}}
                    onMouseOut={e=>{e.currentTarget.style.background="rgba(201,168,76,.12)"}}>
                    Download Full YAML
                  </button>
                </div>
              )}

              <button className="load-btn" onClick={loadFromRepo} disabled={loading || !repoAPI || repoLoading}>
                {loading ? "Loading from repository…" : `Load ${repoAPI || "API"} from ${repoVersion} →`}
              </button>
            </>)}
          </div>
        )}

        {/* ── STEP 2: SELECT ── */}
        {step === "select" && specInfo && (
          <div>
            <div className="select-header">
              <div>
                <div className="spec-title">{specInfo.title || "API Spec"}</div>
                <div className="spec-meta">
                  v{specInfo.version} · {specInfo.total_operations} operations · {specInfo.total_schemas} schemas
                </div>
              </div>
              <button onClick={() => setStep("upload")} style={{fontFamily:"var(--mono)",fontSize:10,
                background:"transparent",border:"1px solid var(--border2)",borderRadius:6,
                color:"var(--dim)",padding:"6px 12px",cursor:"pointer"}}>
                ← Change file
              </button>
            </div>

            {/* Use case shortcuts */}
            {specInfo.use_cases?.length > 0 && (
              <div style={{marginBottom:24}}>
                <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",
                  textTransform:"uppercase",color:"var(--muted)",marginBottom:12}}>
                  Quick select by use case
                </div>
                <div className="use-cases">
                  {specInfo.use_cases.map(uc => (
                    <div key={uc.id}
                      className={`use-case-card${activeUseCase?.id === uc.id ? " active" : ""}`}
                      onClick={() => selectUseCase(uc)}>
                      <div className="use-case-icon">{uc.icon}</div>
                      <div className="use-case-label">{uc.label}</div>
                      <div className="use-case-desc">{uc.description}</div>
                      <div style={{marginTop:8,fontFamily:"var(--mono)",fontSize:9,color:"var(--amber)"}}>
                        {uc.operation_ids.length} operations
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Filter bar */}
            <div className="ops-filter">
              {["ALL","GET","POST","PUT","PATCH","DELETE"].map(m => (
                <button key={m} className={`filter-btn ${filterMethod === m ? "active" : ""}`}
                  onClick={() => setFilterMethod(m)}>{m}</button>
              ))}
              <input className="filter-search" value={filterSearch}
                onChange={e => setFilterSearch(e.target.value)} placeholder="Search operations…" />
              <div className="sel-actions">
                <button className="sel-btn" onClick={selectAll}>All</button>
                <button className="sel-btn" onClick={selectNone}>None</button>
              </div>
            </div>

            {/* Operations list */}
            <div className="ops-list">
              {filteredOps.length === 0 && (
                <div style={{padding:24,textAlign:"center",fontFamily:"var(--mono)",fontSize:12,color:"var(--dim)"}}>
                  No operations match filter
                </div>
              )}
              {filteredOps.map((op, i) => {
                const key = `${op.method}:${op.path}`;
                const isSelected = selectedOps.has(key);
                return (
                  <div key={i} className={`op-row ${isSelected ? "selected" : ""}`} onClick={() => toggleOp(key)}>
                    <input type="checkbox" className="op-check" checked={isSelected} onChange={() => toggleOp(key)} onClick={e => e.stopPropagation()} />
                    <MethodBadge method={op.method} />
                    <span className="op-path">{op.path}</span>
                    <span className="op-summary">{op.summary}</span>
                    <span className="op-id">{op.operation_id}</span>
                  </div>
                );
              })}
            </div>

            {/* Trim bar */}
            <div className="build-bar">
              <div className="build-count">
                <strong>{selectedOps.size}</strong> of {specInfo.total_operations} operations selected
                {selectedOps.size > 0 && <span style={{color:"var(--muted)",marginLeft:8}}>— schemas will be resolved automatically</span>}
              </div>
              <button className="build-btn" onClick={buildSpec} disabled={buildming || selectedOps.size === 0}>
                {buildming ? "Building…" : "Build API →"}
              </button>
            </div>
          </div>
        )}

        {/* ── STEP 3: RESULT ── */}
        {step === "result" && buildResult && (
          <div>
            <div style={{fontSize:24,fontWeight:800,marginBottom:20,color:"var(--amber)"}}>
              Spec Built Successfully
            </div>

            {/* Validation banner */}
            {buildResult.validation && (
              <>
                <div className={`validation-banner ${buildResult.validation.summary?.is_valid ? "valid" : "invalid"}`}>
                  <span style={{fontSize:20}}>{buildResult.validation.summary?.is_valid ? "✅" : "⚠️"}</span>
                  <div style={{flex:1}}>
                    <div>{buildResult.validation.summary?.is_valid
                      ? "Built spec is STAR compliant — ready to download!"
                      : `${buildResult.validation.summary?.errors} error${buildResult.validation.summary?.errors !== 1 ? "s" : ""} · ${buildResult.validation.summary?.warnings} warning${buildResult.validation.summary?.warnings !== 1 ? "s" : ""} found in built spec`}
                    </div>
                    <div style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:400,color:"var(--muted)",marginTop:2}}>
                      {buildResult.validation.summary?.passed} checks passed
                    </div>
                  </div>
                  {!buildResult.validation.summary?.is_valid && (
                    <button onClick={fixAll} disabled={fixing}
                      style={{padding:"8px 18px",borderRadius:7,border:"none",
                        background:"linear-gradient(135deg, #c9a84c, #b8943d)",
                        color:"#1a1f2e",fontFamily:"var(--sans)",fontWeight:700,
                        fontSize:13,cursor:"pointer",whiteSpace:"nowrap",
                        opacity: fixing ? .6 : 1}}>
                      {fixing ? "Fixing…" : "🔧 Fix All Errors"}
                    </button>
                  )}
                </div>

                {/* Error list */}
                {!buildResult.validation.summary?.is_valid && (
                  (() => {
                    const errors = buildResult.validation.errors || [];
                    const warnings = buildResult.validation.warnings || [];
                    const allIssues = [
                      ...errors.map(e => ({...e, severity: "ERROR"})),
                      ...warnings.map(w => ({...w, severity: "WARNING"}))
                    ];
                    if (allIssues.length === 0) return null;
                    return (
                      <div style={{marginBottom:20,background:"var(--bg2)",border:"1px solid var(--border)",
                        borderRadius:10,overflow:"hidden"}}>
                        <div style={{padding:"10px 16px",background:"var(--bg3)",borderBottom:"1px solid var(--border)",
                          fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
                          color:"var(--muted)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                          <span>Validation Issues</span>
                          <span style={{color:"var(--amber)"}}>{errors.length} errors · {warnings.length} warnings</span>
                        </div>
                        <div style={{maxHeight:280,overflowY:"auto"}}>
                          {allIssues.map((issue, i) => (
                            <div key={i} style={{display:"flex",gap:12,padding:"10px 16px",
                              borderBottom:"1px solid var(--border)",alignItems:"flex-start",
                              background: i % 2 === 0 ? "transparent" : "rgba(255,255,255,.02)"}}>
                              <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,
                                padding:"2px 7px",borderRadius:4,whiteSpace:"nowrap",flexShrink:0,
                                background: issue.severity === "ERROR" ? "rgba(239,68,68,.15)" : "rgba(245,158,11,.15)",
                                color: issue.severity === "ERROR" ? "#f87171" : "#fbbf24"}}>
                                {issue.severity}
                              </span>
                              <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)",
                                whiteSpace:"nowrap",flexShrink:0}}>{issue.rule}</span>
                              <span style={{fontSize:13,color:"var(--text)",flex:1}}>{issue.message}</span>
                              {issue.path && (
                                <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",
                                  whiteSpace:"nowrap"}}>{issue.path}</span>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()
                )}

                {/* Fixed notice */}
                {fixedYaml && buildResult.validation.summary?.is_valid && (
                  <div style={{padding:"10px 16px",background:"rgba(16,185,129,.1)",
                    border:"1px solid rgba(16,185,129,.3)",borderRadius:8,marginBottom:16,
                    fontFamily:"var(--mono)",fontSize:11,color:"#10b981"}}>
                    ✅ All errors fixed automatically! Download the corrected spec below.
                  </div>
                )}
              </>
            )}

            {/* Stats */}
            <div className="result-grid">
              <div className="stat-card">
                <div className="stat-label">Size Reduction</div>
                {[
                  ["Operations", buildResult.stats.original.operations, buildResult.stats.trimmed.operations, buildResult.stats.reduction.operations_pct],
                  ["Schemas", buildResult.stats.original.schemas, buildResult.stats.trimmed.schemas, buildResult.stats.reduction.schemas_pct],
                  ["Lines", buildResult.stats.original.size_lines, buildResult.stats.trimmed.size_lines, buildResult.stats.reduction.size_pct],
                ].map(([label, before, after, pct]) => (
                  <div key={label} className="stat-row">
                    <span>{label}</span>
                    <span className="stat-before">{before?.toLocaleString()}</span>
                    <span>→</span>
                    <span className="stat-after">{after?.toLocaleString()}</span>
                    <span className="stat-reduction">-{pct}%</span>
                  </div>
                ))}
              </div>

              <div className="stat-card">
                <div className="stat-label">Selected Operations</div>
                <div style={{maxHeight:140,overflowY:"auto"}}>
                  {Array.from(selectedOps).map((op, i) => {
                    const [method, ...pathParts] = op.split(":");
                    const path = pathParts.join(":");
                    return (
                      <div key={i} style={{display:"flex",gap:8,alignItems:"center",padding:"5px 0",
                        borderBottom:"1px solid var(--border)"}}>
                        <MethodBadge method={method} />
                        <span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)"}}>{path}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Sticky action bar — step 3 */}
            <div style={{position:"sticky",bottom:16,zIndex:50,
              background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,
              padding:"14px 20px",marginTop:16,
              display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",
              boxShadow:"0 4px 24px rgba(0,0,0,.4)"}}>
              <button className="restart-btn" style={{margin:0}}
                onClick={() => { setStep("select"); setBuildResult(null); }}>
                ← Back
              </button>
              <div style={{flex:1}} />
              {fixedYaml ? (
                <button className="download-btn" style={{margin:0}} onClick={() => downloadBuilt(fixedYaml)}>
                  Download Fixed YAML
                </button>
              ) : (
                <>
                  <button className="download-btn" style={{margin:0}} onClick={() => downloadBuilt()}>
                    Download
                  </button>
                  {!buildResult.validation?.summary?.is_valid && (
                    <button onClick={() => downloadBuilt()} style={{
                      padding:"10px 20px",borderRadius:8,border:"1px solid var(--border2)",
                      background:"transparent",color:"var(--muted)",fontFamily:"var(--sans)",
                      fontWeight:600,fontSize:13,cursor:"pointer"}}>
                      Download anyway
                    </button>
                  )}
                </>
              )}
            </div>
            <button className="restart-btn" style={{marginTop:8}} onClick={reset}>
              Start over
            </button>
          </div>
        )}
      </div>
    </>
  );
}
